import VideoAttribution, { videoPath } from "@/components/VideoAttribution";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Bookmark, BookmarkCheck, Zap, Sparkles } from "lucide-react";
import PlatformBadge from "@/components/PlatformBadge";
import MediaImage from "@/components/MediaImage";
import { explicitDemoMedia } from "@/lib/media";
import { formatNumber, classNames } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

export default function HookCard({ item, onToggle }) {
  const { canEdit } = useAuth();
  const legacyScore = item.evidence_status !== "metadata_only" && typeof item.score === "number" && Number.isFinite(item.score) && item.score >= 1 && item.score <= 10;
  return (
    <Card className="p-4 flex flex-col gap-3" data-testid={`hook-card-${item.video_id}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="inline-flex items-center rounded-full bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 truncate" title={item.pattern_full}>{item.pattern}</span>
        <div className="flex items-center gap-2 shrink-0">
          {item.auto && <Sparkles className="h-3.5 w-3.5 text-primary" title="Auto-analyzed" />}
          <span className="text-xs text-muted-foreground" data-testid={`hook-score-${item.video_id}`}>{legacyScore ? `Ancien score non vérifié : ${item.score}/10` : "Score indisponible"}</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground" data-testid={`hook-evidence-${item.video_id}`}>{item.evidence_status === "metadata_only" ? "Interprétation textuelle" : "Ancienne analyse — preuves non vérifiées"} · Extrait textuel, pas une ouverture parlée vérifiée.</p>
      <Link to={videoPath(item)} className="font-display text-base font-bold leading-snug hover:underline line-clamp-3" data-testid={`hook-text-${item.video_id}`}>
        “{item.hook_text}”
      </Link>
      {item.top_driver && <p className="text-xs text-muted-foreground line-clamp-2">Hypothèse non prouvée : {item.top_driver}</p>}
      <VideoAttribution video={item} />
      <div className="mt-auto pt-3 border-t border-border flex items-center gap-2 text-xs">
        <MediaImage src={item.creator_avatar} alt="" name={item.creator_handle} kind="avatar" demo={explicitDemoMedia(item)} className="h-5 w-5 rounded-full object-cover" />
        <span className="truncate text-muted-foreground">{item.creator_handle}</span>
        <PlatformBadge platform={item.platform} size="xs" />
        <span className="ml-auto font-mono text-muted-foreground">{formatNumber(item.views)}</span>
        <span className={classNames("font-mono font-bold inline-flex items-center gap-0.5", item.is_outlier ? "text-[hsl(var(--emerald))]" : "text-muted-foreground")}>
          {item.is_outlier && <Zap className="h-3 w-3" />}{item.outlier_multiplier.toFixed(1)}x
        </span>
        {canEdit && <button onClick={() => { if (canEdit) onToggle(); }} title={canEdit ? "Save to swipe file" : "Viewers have read-only access"} className={classNames("ml-1 rounded-md p-1 transition-colors disabled:opacity-40", item.swipe_id ? "text-primary" : "text-muted-foreground hover:text-foreground")} aria-label="Save to swipe file" data-testid={`hook-swipe-${item.video_id}`}>
          {item.swipe_id ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
        </button>}
      </div>
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground -mt-1">{item.niche}</div>
    </Card>
  );
}
